module.exports = __webpack_public_path__ + "img/45_25.ea91bf63.png";